import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";

export default function Layout() {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col font-sans text-gray-900">
      <Navbar />
      <main className="flex-grow pt-24 md:pt-28 animate-fade-in key={location.pathname}">
        {/* The key prop on a parent of Outlet or the Outlet itself forces re-render and animation restart */}
        <div key={location.pathname} className="animate-fade-in">
            <Outlet />
        </div>
      </main>
      <footer className="bg-vinefin-950 text-white py-8 text-center text-sm">
        <div className="container mx-auto px-4">
          <p>&copy; {new Date().getFullYear()} Vinefin. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
